import { stateAddApi } from "../../api/state/stateAddApi"

type PayloadShape = Parameters<typeof stateAddApi>[0]

export async function stateAddService(payload: PayloadShape, token: string) {
	return await stateAddApi(payload, token)
}
